var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVeryHappyIconSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "url(#paint0_linear_2428_63462)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2428_63462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 45C36.0457 45 45 36.0457 45 25C45 13.9543 36.0457 5 25 5C13.9543 5 5 13.9543 5 25C5 36.0457 13.9543 45 25 45Z",
    fill: "#6BCA6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.459 25H39.4803C39.4803 25 41.27 38.7091 25.2212 38.7091C25.2212 38.7091 10.459 39.5861 10.459 25Z",
    fill: "#417F41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7958 19.9733C13.7958 19.9733 12.9965 15.1797 16.5468 15.1797C20.097 15.1797 19.5648 19.9733 19.5648 19.9733",
    stroke: "#417F41",
    strokeWidth: 1.417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2055 19.9733C36.2055 19.9733 37.0048 15.1797 33.4545 15.1797C29.9043 15.1797 30.4365 19.9733 30.4365 19.9733",
    stroke: "#417F41",
    strokeWidth: 1.417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2428_63462",
    x1: 25,
    y1: 0,
    x2: 25,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2428_63462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeryHappyIconSvg);
export default __webpack_public_path__ + "static/media/veryHappy-icon-svg.f45fa3a2ff573a2ffb82c919fd665b05.svg";
export { ForwardRef as ReactComponent };